export default __webpack_public_path__ + "static/media/PROF2024.dac85fc0.pdf";